import { render, staticRenderFns } from "./remove.vue?vue&type=template&id=303a2eb4&"
import script from "./remove.vue?vue&type=script&lang=js&"
export * from "./remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303a2eb4')) {
      api.createRecord('303a2eb4', component.options)
    } else {
      api.reload('303a2eb4', component.options)
    }
    module.hot.accept("./remove.vue?vue&type=template&id=303a2eb4&", function () {
      api.rerender('303a2eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/remove.vue"
export default component.exports